

export class ItemForBrandReq{
   brandId:number;
   itemSubCategoryId:number
}